import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { eFilterFieldType } from "@hub/generated/enums";
import { AFilterBase, FilterCollection, FilterValueCollection, GridDto } from "@hub/generated/models";
import { FilterService } from "@hub/services/FilterService";
import { FilterHelpers } from "@hub/core/helpers/FilterHelpers";
import { Functions } from "@hub/common/Functions";

@Component({
  selector: "app-filterHolder",
  templateUrl: "./filterHolder.component.html",
  styleUrls: ["./filterHolder.component.scss"]
})
export class FilterHolderComponent implements OnInit {
  constructor(private service: FilterService) { }

  private _grid: GridDto;
  @Input() set grid(grid: GridDto) {
    this._grid = grid;
    if (grid) {
      this.setFilters();
      this.filterCollection = this.grid.AppliedFilters;
      this.originalFilterCollection = Functions.cloneObject(this.grid.AppliedFilters);
    }
  }
  get grid(): GridDto {
    return this._grid;
  }

  @Output() onFilterChange = new EventEmitter<FilterCollection>();
  public filterCollection: FilterCollection;
  public originalFilterCollection: FilterCollection;
  public IsOpened: boolean = false;
  public Type = eFilterFieldType;
  public filters: AFilterBase[];

  // OnInit
  public ngOnInit(): void { }

  // Public Methods
  public toggleFilter(): void {
    this.IsOpened = !this.IsOpened;
  }

  public filterChanged(value: FilterValueCollection): void {
    this.filterCollection = FilterHelpers.addOrUpdateFilter(this.filterCollection, value);
  }

  public search(): void {
    this.toggleFilter();
    this.onFilterChange.emit(this.filterCollection);
  }

  public reset() {
    this.filterCollection = Functions.cloneObject(this.originalFilterCollection);
    this.search();
  }


  public setFilters() {
    this.filters = [];
    // TODO:
    this.grid.Filters.forEach(
      element => {
        if (element != null) {
          if (element.FilterType !== eFilterFieldType.Container) {
            this.filters.push(element);
          } else {
            this.getSubFilters(
              element,
              element.ColumnName,
              this.filters
            );
          }
        }
      }
    );

    this.filters = this.filters
      .filter(f => f.FilterType !== eFilterFieldType.Container)
      .sort((a, b) => a.SortOrder - b.SortOrder);
  }

  private getSubFilters(
    filter: AFilterBase,
    name: string,
    target: AFilterBase[]
  ): void {
    if (filter.SubFilters != null && filter.SubFilters.length > 0) {
      filter.SubFilters.forEach(element => {
        if (element.FilterType !== eFilterFieldType.Container) {
          element.ColumnName = name + "|" + element.ColumnName;
          target.push(element);
        } else
          this.getSubFilters(element, name + "|" + element.ColumnName, target);
      });
    }
  }

  // protected getFilterCollection() {
  //   if (!this.service.isEdited)
  //     this.filterCollection = this.grid.AppliedFilters;

  //   return this.filterCollection;
  // }
}
